export default function News() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" viewBox="0 0 23 21" fill="none">
            <path
                d="M3.6256 6.51151L15.6572 1.62117C16.2588 1.37666 16.9442 1.67039 17.1821 2.27462L18.85 6.51151M7.8244 11.5171H10.9756M7.8244 14.7176H15.1756M22 9.71197V7.67818C22 7.03384 21.4777 6.51151 20.8333 6.51151H2.16667C1.52233 6.51151 1 7.03384 1 7.67818V9.71197C2.5744 9.71197 4.15 10.7784 4.15 12.9124C4.15 15.0465 2.5756 16.1129 1 16.1129V18.1467C1 18.791 1.52233 19.3134 2.16667 19.3134H20.8333C21.4777 19.3134 22 18.791 22 18.1467V16.1129C20.4256 16.1129 18.85 14.5121 18.85 12.6452C18.85 10.7784 20.4256 9.71197 22 9.71197Z"
                stroke="#3F68E0"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
}
